import React, { createContext, useEffect, useState } from "react";
import { RESET_STATE_TRANSFER_ASSET } from "../ui";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", data, children }) => {
  const [formData, setFormData] = useState(RESET_STATE_TRANSFER_ASSET);
  const [listTF, setListTF] = useState([]);

  useEffect(() => {
    setFormData(data);
  }, [data]);

  return (
    <FormContext.Provider value={{ formData, setFormData, listTF, setListTF }}>
      {children}
    </FormContext.Provider>
  );
};
